// Layout breakpoint helpers — single source of truth, no window globals.
// Breakpoints match static_html/src/assets/js/constants/sizes.js and the
// Tailwind config, so JS and CSS agree on what "mobile" and "tablet" mean.

import { DESKTOP_SCREEN_CUTOFF } from '@Constants';

const MOBILE_MAX = 600;

const mobileQuery = window.matchMedia(`(max-width: ${MOBILE_MAX}px)`);
const tabletQuery = window.matchMedia(
  `(min-width: ${MOBILE_MAX + 1}px) and (max-width: ${DESKTOP_SCREEN_CUTOFF -
    1}px)`
);
const nonDesktopQuery = window.matchMedia(
  `(max-width: ${DESKTOP_SCREEN_CUTOFF - 1}px)`
);

export const isMobileLayout = () => mobileQuery.matches;
export const isTabletLayout = () => tabletQuery.matches;
export const isMobileOrTablet = () => nonDesktopQuery.matches;

// Emit a bubbling 'layout-shift-required' event on any breakpoint cross so
// components that need to re-render on layout change (e.g. walter) can listen.
const dispatchLayoutShift = () => {
  document.dispatchEvent(
    new Event('layout-shift-required', { bubbles: true, composed: true })
  );
};
mobileQuery.addEventListener('change', dispatchLayoutShift);
tabletQuery.addEventListener('change', dispatchLayoutShift);
